import articles from './sections/articles';
import cta from './sections/cta';
import hero from './sections/hero';

const translations = {
    page: {
        metaTitle: 'Blog',
        metaDescription: 'Blog',
    },
    sections: {
        hero,
        articles,
        cta,
    },
};

export default translations;
